import React from 'react';
import {Image} from 'react-native';
import Btn from 'components/Btn';
import Div from 'lib/Div';
import P from 'lib/P';
import {flowStyles, SignatureResultSurface} from 'modals/withdraw-flow/WithdrawFlowPrimitives';
import evenplayLogo from 'assets/img/evenplay-logo-long.svg';
import DepositSuccessIcon from './DepositSuccessIcon';
import {styles} from '../styles';
import {SummaryLine} from '../types';

type Props = {
  depositAmountLabel: string, successLines: SummaryLine[], onPlayNow: () => void, onViewTransaction: () => void
};

const renderDepositSuccessSummaryLine = (line: SummaryLine, index: number, successLines: SummaryLine[]) => {
  const isLast = index === successLines.length - 1;
  const isNewBalance = index === 0;

  return (
    <Div key={line.label} row justifyContent="space-between" alignItems="center" gap={12} py={12}
         borderBottomWidth={isLast ? 0 : 1} borderColor="rgba(235, 255, 247, 0.08)">
      <P fontFamily="POI Aeronaut" fs={13} lh={19.5} color="#97a8a6" flex={1}>{line.label}</P>
      <P fontFamily="POI Aeronaut" fs={14} lh={21} color={isNewBalance ? '#27e9a6' : '#ffffff'} ta="right"
         fontVariant={['tabular-nums']} style={styles.mediumText}>
        {line.value}
      </P>
    </Div>
  );
};

const DepositSuccessStep = ({depositAmountLabel, successLines, onPlayNow, onViewTransaction}: Props) => (
  <>
    <Div h={56} row alignItems="center" px={12} bg="#1b3131">
      <Div w={56}/>
      <Div flex={1} alignItems="center">
        <Image source={evenplayLogo as any} style={flowStyles.resultBrandLogo}/>
      </Div>
      <Div w={56}/>
    </Div>

    <SignatureResultSurface>
      <Div testID="add-card-success-signature-surface" flex={1}>
        <DepositSuccessIcon/>

        <Div alignItems="center" mt={18}>
          <P fontFamily="POI Orbiter" fs={30} lh={36} ls={-0.3} color="#ffffff" ta="center" style={styles.boldText}>
            Deposit Complete
          </P>
          <P fontFamily="POI Orbiter" fs={56} lh={58.8} ls={-1.12} color="#27e9a6" ta="center" mt={10}
             fontVariant={['tabular-nums']} style={styles.boldText}>
            {depositAmountLabel}
          </P>
          <P fontFamily="POI Aeronaut" fs={14} lh={20.3} color="#97a8a6" ta="center" mt={6}>added to your wallet</P>
        </Div>

        <Div mt={24} bg="rgba(10, 28, 28, 0.7)" borderWidth={1} borderColor="rgba(235, 255, 247, 0.08)" rounded={16}
             px={18} py={4}>
          {successLines.map((line, index) => renderDepositSuccessSummaryLine(line, index, successLines))}
        </Div>

        <Div flex={1} minH={16}/>

        <Div gap={10}>
          <Btn h={52} w="100%" px={28} rounded={999} bg="#27e9a6" alignItems="center" justifyContent="center"
               onPress={onPlayNow} accessibilityRole="button">
            <P fontFamily="POI Aeronaut" fs={14} lh={21} ls={0.84} tt="uppercase" color="#1b3131"
               style={styles.mediumText}>
              Play Now
            </P>
          </Btn>

          <Btn h={52} w="100%" px={28} rounded={999} bg="#0a1c1c" alignItems="center" justifyContent="center"
               onPress={onViewTransaction} accessibilityRole="button">
            <P fontFamily="POI Aeronaut" fs={14} lh={21} ls={0.84} tt="uppercase" color="#ffffff"
               style={styles.mediumText}>
              View Transaction
            </P>
          </Btn>
        </Div>
      </Div>
    </SignatureResultSurface>
  </>
);

export default DepositSuccessStep;
